import { render, staticRenderFns } from "./RolesSeguridadTab.vue?vue&type=template&id=9f8c4eb4&scoped=true&lang=pug"
import script from "./RolesSeguridadTab.vue?vue&type=script&lang=js"
export * from "./RolesSeguridadTab.vue?vue&type=script&lang=js"
import style0 from "./RolesSeguridadTab.vue?vue&type=style&index=0&id=9f8c4eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8c4eb4",
  null
  
)

export default component.exports